import { render, staticRenderFns } from "./CPageMenuIndexStandard.vue?vue&type=template&id=65a23d0e&"
import script from "./CPageMenuIndexStandard.vue?vue&type=script&lang=ts&"
export * from "./CPageMenuIndexStandard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports